import { AccordionStyleThree } from 'common/accordion/accordion-style-3.js';
import { IconWithText } from 'common/icon/icon-with-text.js';
import { LegendKeys } from 'components/legends/legend-keys.js';
import { memo } from 'react';
import { IMapGeneralKeyContent, IMapKey } from 'types/location.js';

const LegendsKeysCore = ({ keys }: { keys?: IMapKey[] }) => {
  if (keys) {
    if (keys.length === 1) {
      return <LegendKeys {...keys[0]} showLabel />;
    }

    /** We know that custom headers dont have multiple tabs */
    const items = (keys as IMapGeneralKeyContent[]).map((key, index) => {
      const { icon, label } = key;

      return {
        key: index.toString(),
        title: (
          <IconWithText
            iconClass="svg-fill-font-color u-textSlate"
            key={index}
            icon={icon}
            classes="IconWithText--small IconWithText--vCenter"
          >
            <small>{label}</small>
          </IconWithText>
        ),
        text: <LegendKeys {...key} showLabel={false} />,
      };
    });

    return (
      <AccordionStyleThree
        headerContent={(item) => item.title}
        bodyContent={(item) => item.text}
        items={items}
        defaultToOpen={false}
        openIndexAsDefault={false}
        restrictToOnlyOneChildOpen={true}
      />
    );
  }
};

export const LegendsKeys = memo(LegendsKeysCore);
